// extracted by mini-css-extract-plugin
module.exports = {"fullHeight":"Grid_fullHeight__2wH4K","fullWidth":"Grid_fullWidth__15fpe"};